export default {
  ONLINE_STORE_BLOCK: 'online-store',
  ONLINE_STORE_SELECTOR: 'ws-online-store',
  STORE_ID_ATTRIBUTE: 'store-id',
};
